var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.5,
    r: 14.5,
    fill: "white",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_176_1041",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_176_1041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.525 25.5L25.35 24.25L28.85 21.65L31 22.9L27.525 25.5ZM22.8 22.45L25.4 20.475L18.5 16.5L17 19.1L22.8 22.45ZM14 30.5V28.5H19V22.55L16 20.825C15.5167 20.5417 15.2042 20.1375 15.0625 19.6125C14.9208 19.0875 14.9917 18.5833 15.275 18.1L16.775 15.5C17.0583 15.0167 17.4625 14.7042 17.9875 14.5625C18.5125 14.4208 19.0167 14.4917 19.5 14.775L29.025 20.275L22.925 24.825L21 23.725V28.5C21 29.05 20.8042 29.5208 20.4125 29.9125C20.0208 30.3042 19.55 30.5 19 30.5H14Z",
    fill: "#0066FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraButton);
export default __webpack_public_path__ + "static/media/cameraButton.70ee3869f6e5b514d6f565bae4395689.svg";
export { ForwardRef as ReactComponent };